import { searchCustomers } from "../api.js";

const MAX_CUSTOMERS = 8;

// Los que salen del índice en caché (búsqueda sin puntos ni espacios) no
// traen teléfono ni grupo de precio
export const customerOf = result => ({
  personaId: result.personaId,
  name: result.nombreComp,
  email: result.email1 || null,
  phone: ((result.telefono || [])[0] || {}).numero || null,
  priceGroup: result.grupoPrecio || null
});

export default {
  definition: {
    name: "find_customer",
    description:
      "Busca clientes de Infoauto por nombre, documento, correo o teléfono y le muestra los candidatos al vendedor en una tarjeta para que elija uno. El cliente elegido es el de la cotización. El nombre no tiene que ser exacto: ignora puntos, espacios y mayúsculas ('fd parts' encuentra 'F.D. PARTS INC'), basta con algunas palabras del nombre. Si no sale nada, prueba con menos palabras antes de pedir otro dato.",
    strict: true,
    input_schema: {
      type: "object",
      properties: {
        query: {
          type: "string",
          description: "Nombre, documento, correo o teléfono del cliente"
        }
      },
      required: ["query"],
      additionalProperties: false
    }
  },

  async run({ query }, ctx) {
    const res = await searchCustomers(query, ctx.departamentoId, MAX_CUSTOMERS);
    const customers = (Array.isArray(res.data) ? res.data : []).map(customerOf);
    return {
      card: { type: "customerOptions", customers },
      content: JSON.stringify({
        shownToUserAsCard: true,
        // Con uno solo la tarjeta ya lo deja elegido
        selected: customers.length === 1 ? customers[0].personaId : null,
        customers: customers.map(customer => ({
          personaId: customer.personaId,
          name: customer.name,
          email: customer.email
        }))
      })
    };
  }
};
